var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1125_89942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3 21.2V19.2C17.3 18.1391 16.8786 17.1217 16.1285 16.3715C15.3783 15.6214 14.3609 15.2 13.3 15.2H5.30005C4.23918 15.2 3.22177 15.6214 2.47162 16.3715C1.72148 17.1217 1.30005 18.1391 1.30005 19.2V21.2",
    stroke: "#414141",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.30005 11.2C11.5092 11.2 13.3 9.40909 13.3 7.19995C13.3 4.99081 11.5092 3.19995 9.30005 3.19995C7.09091 3.19995 5.30005 4.99081 5.30005 7.19995C5.30005 9.40909 7.09091 11.2 9.30005 11.2Z",
    stroke: "#414141",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3 21.2V19.2C23.2994 18.3137 23.0044 17.4527 22.4614 16.7523C21.9184 16.0518 21.1582 15.5515 20.3 15.33",
    stroke: "#414141",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3 3.32996C17.1605 3.55026 17.9231 4.05066 18.4677 4.75227C19.0123 5.45388 19.3079 6.31679 19.3079 7.20496C19.3079 8.09313 19.0123 8.95604 18.4677 9.65765C17.9231 10.3593 17.1605 10.8597 16.3 11.08",
    stroke: "#414141",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1125_89942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.300049 0.199951)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.682c82e6792d12e02feb04270883d6bc.svg";
export { ForwardRef as ReactComponent };